"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Exports a boolean value reporting whether is client side or server side by checking on the window object
 */

var isClient = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.default = isClient;